import { Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";

const useStyle = makeStyles((theme) => ({
  hrmsDepartmentSearch: {
    cursor: "pointer",
    margin: "5px 0px",
  },
}));

const DepartmentSearch = ({ highlightText, item }) => {
  const navigate = useNavigate();

  const classes = useStyle();

  const handleRedirect = () => {
    navigate("/departments");
  };
  return (
    <Grid className={classes.hrmsDepartmentSearch} onClick={handleRedirect}>
      <Typography>{highlightText(item.department_name)}</Typography>
    </Grid>
  );
};

export default DepartmentSearch;
